import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import 'yet-another-react-lightbox/styles.css';
import { IoMdArrowRoundBack } from "react-icons/io";
import { RiDeleteBinLine } from "react-icons/ri";
import ApiClient from "../../api-client";
import "./AddProvider.css"
import debounce from 'lodash.debounce';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Spinner,
  CardImg,
  Form,
  FormGroup,
  Input,
} from "reactstrap";
import { generateTempPassword } from "../../utils/common";
import axios from "axios";

function AddProvider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profilePicPrev, setProfilePicPrev] = useState();
  const [loader, setLoader] = useState(false);
  const [inputName, setInputName] = useState("");
  const [errors, setErrors] = useState({});
  const [fileInputKey, setFileInputKey] = useState(Date.now()); 
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    gender: "",
    dateOfBirth: "",
    address1: "",
    address2: "",
    city: "",
    pincode: "",
    experience:"",
    specialties:"",
    removedImages:"",
    qualifications:"",
    profilePic: "",
    identityVerificationDoc: [],
    certificateDoc: [],
    addressVerificationDoc: []
  });
  const [address, setAddress] = useState('');
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  const validate = () => {
    const errors = {};
    if (!formData.firstName) {
      errors.firstName = "First name is required";
    }
    if (!formData.lastName) {
      errors.lastName = "Last name is required";
    }
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email address is invalid";
    }
    
    if (formData.identityVerificationDoc.length === 0) {
      errors.identityVerificationDoc = "Identity verification document is required";
    }
    if (formData.certificateDoc.length === 0) {
      errors.certificateDoc = "Certificate document is required";
    }
    if (formData.addressVerificationDoc.length === 0) {
      errors.addressVerificationDoc = "Address verification document is required";
    }
    return errors;  
  };

  useEffect(() => {
    if (inputName) {
      console.log(inputName)
      const validationErrors = validate();
      setErrors((previousData) => {
        return {
          ...previousData,
          [inputName]: validationErrors[inputName] || "",
        };
      });
    }
  }, [inputName, formData]);


  // const handleImageChange = (e, docType) => {
  //   const files = Array.from(e.target.files);
  //   console.log(files,"files")

  //   setFormData((previousData) => {
  //     return {
  //       ...previousData,
  //       [docType]: [...previousData[docType], ...files],
  //     };  
  //   });
 
  // };


  const handleImageChange = (e, docType) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
    let hasInvalidFile = false;

    files.forEach(file => {
      if (file.size > 5 * 1024 * 1024) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [docType]: "File size should be less than 5 MB",
        }));
        hasInvalidFile = true;
      } else {
        validFiles.push(file);
      }
    });

    if (!hasInvalidFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [docType]: "",
      }));
      setFormData((previousData) => ({
        ...previousData,
        [docType]: [...previousData[docType], ...validFiles],
      }));
    }
  };

 
  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      // File size check (5 MB limit)
      setErrors((prevErrors) => ({
        ...prevErrors,
        profilePic: "File size should be less than 5 MB",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        profilePic: "",
      }));
      setFormData((previousData) => ({
        ...previousData,
        profilePic: file,
      }));
      setProfilePicPrev(URL.createObjectURL(file));
    }
  };

  
  const handleRemoveImage = (docType, index) => {
    setFormData((previousData) => {
      const updatedDocs = [...previousData[docType]];
      updatedDocs.splice(index, 1);
      return {
        ...previousData,
        [docType]: updatedDocs.length > 0 ? updatedDocs : [],
      };
    });

    setInputName(formData[docType]); // Trigger validation check after image removal

    // Reset file input if all images are removed
    if (formData[docType].length === 1) {
      setFileInputKey(Date.now());
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormData((previousData) => {
      return {
        ...previousData,
        [name]: value
      };
    });
    setInputName(name);
  };

  const resetForm = () => {
    setProfilePicPrev("");
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      profilePic: "",
      identityVerificationDoc: [],
      certificateDoc: [],
      addressVerificationDoc: []
    });
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setLoader(true);
      try {
        let registerFormData = new FormData();
        const tempPass = generateTempPassword();
        registerFormData.append("role", "provider");
        registerFormData.append("password", tempPass);
        registerFormData.append("confirmPassword", tempPass);
        for (const key in formData) {
          console.log(key,"key")
          console.log(formData[key])
          if (key === "profilePic") {
               // Check if profilePic is not empty and append it as a file
                if (formData[key]) {
                  registerFormData.append(key,formData[key]);
                }
            } else if (
            key === "identityVerificationDoc" ||
            key === "certificateDoc" ||
            key === "addressVerificationDoc"
          ) {
            formData[key].forEach((file, index) => {
              registerFormData.append(key, file);
            });
          } else {
            registerFormData.append(key, formData[key]);
          }
        }

        const response = await ApiClient._postFormData("api/users/signup/provider", registerFormData);
        toast.success(response.data.message, { autoClose: 3000 });
        resetForm();
        navigate("/admin/provider/list");
      } catch (error) {
        toast.error(error.response.data.message, { autoClose: 3000 });
      } finally {
        setLoader(false);
      }
    }
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
    // debouncedGetCoordinates(e.target.value);
  };
  // const getCoordinates = async (address) => {
  //   const API_KEY = 'YOUR_GOOGLE_MAPS_API_KEY';
  //   if (!address) return;
    
  //   try {
  //     const response = await axios.get(
  //     `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${API_KEY}`
  //     );
  //     if (response.data.status === 'OK') {
  //       const location = response.data.results[0].geometry.location;
  //       setCoordinates({ lat: location.lat, lng: location.lng });
  //     } else {
  //       console.error('Geocoding API error:', response.data.status);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching coordinates:', error);
  //   }
  // };

  // const debouncedGetCoordinates = debounce(getCoordinates, 500);
  return (
    <>
      <div className="content">
        <Button
          color="primary"
          className="ml-10 common-button"
          onClick={() => navigate("/admin/provider/list")}
        >
          <IoMdArrowRoundBack /> Back
        </Button>
        <Container>
          <Card>
            <CardBody className="mb-15">
              <Form>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="firstName">First Name</Label>
                      <Input
                        type="text"
                        name="firstName"
                        id="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <div className="error-message">{errors.firstName}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="lastName">Last Name</Label>
                      <Input
                        type="text"
                        name="lastName"
                        id="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {errors.lastName && (
                        <div className="error-message">{errors.lastName}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        type="text"
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <div className="error-message">{errors.email}</div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="phoneNumber">Phone Number</Label>
                      <Input
                        type="text"
                        name="phoneNumber"
                        id="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors.phoneNumber && (
                        <div className="error-message">
                          {errors.phoneNumber}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="gender">Gender</Label>
                      <Input
                        type="select"
                        name="gender"
                        id="gender"
                        value={formData.gender}
                        onChange={handleChange}
                      >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="dateOfBirth">Date of birth</Label>
                      <Input
                        type="date"
                        name="dateOfBirth"
                        id="dateOfBirth"
                        value={formData.dateOfBirth}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="phoneNumber">Experience</Label>
                      <Input
                        type="text"
                        name="experience"
                        id="experience"
                        value={formData.experience}
                        onChange={handleChange}
                      />
                      {/* {errors.experience && (
                        <div className="error-message">
                          {errors.experience}
                        </div>
                      )} */}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="gender">Specialties</Label>
                      <Input
                        type="text"
                        name="specialties"
                        id="specialties"
                        value={formData.specialties}
                        onChange={handleChange}
                        />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="dateOfBirth">Qualification</Label>
                      <Input
                        type="text"
                        name="qualifications"
                        id="qualifications"
                        value={formData.qualifications}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label for="address1">Address1</Label>
                      <Input
                        type="text"
                        name="address1"
                        id="address1"
                        value={formData.address1}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="address2">Address2</Label>
                      <Input
                        type="text"
                        name="address2"
                        id="address2"
                        value={formData.address2}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="city">City</Label>
                      <Input
                        type="text"
                        name="city"
                        id="city"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="pincode">Pincode</Label>
                      <Input
                        type="text"
                        name="pincode"
                        id="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4"></Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup className="upload_files">
                      <Label for="profilePic">Provider Profile</Label>
                      <Input
                        type="file"
                        name="profilePic"
                        id="profilePic"
                        accept=".jpeg, .jpg, .png"
                        className="file-input"
                        onChange={handleProfilePicChange}
                        style={{width:"55rem"}}
                      />
                      {errors.profilePic && (
                        <div className="error-message">{errors.profilePic}</div>
                      )}
                      {profilePicPrev && (
                        <div className="img-preview-wrapper position-relative">
                          <CardImg
                            alt="Thumbnail"
                            className="img-preview-small"
                            src={profilePicPrev}
                            top
                          />
                          
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <FormGroup className="upload_files">
                      <Label for="identityVerificationDoc">Identity Verification Doc</Label>
                      <Input
                        type="file"
                        key={fileInputKey}
                        name="identityVerificationDoc"
                        id="identityVerificationDoc"
                        accept=".jpeg, .jpg, .png"
                        className="file-input"
                        multiple
                        onChange={(e) => handleImageChange(e, "identityVerificationDoc")}
                        style={{ width: "55rem" }}
                      />
                      {errors.identityVerificationDoc && (
                        <div className="error-message">
                          {errors.identityVerificationDoc}
                        </div>
                      )}
                      {formData.identityVerificationDoc.length > 0 && (
                      <div  className="img-preview-container">
                          {formData.identityVerificationDoc.map((file, index) => (
                            <div
                              key={index}
                              className="img-preview-wrapper position-relative"
                              
                            >
                              <CardImg
                                alt="Thumbnail"
                                className="img-preview-small"
                                src={URL.createObjectURL(file)}
                                top
                                style={{ width: '100px', height: '100px' }} // Adjust the size as needed
                              />
                              <Button
                                color="link"
                                size="sm"
                                className="position-absolute"
                                style={{ top: '0', right: '0', padding: '0' }}
                                onClick={() => handleRemoveImage("identityVerificationDoc", index)}
                              >
                                <RiDeleteBinLine size={24} />
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <FormGroup className="upload_files">
                      <Label for="certificateDoc">Certificate Doc</Label>
                      <Input
                        type="file"
                        key={fileInputKey}
                        name="certificateDoc"
                        id="certificateDoc"
                        accept=".jpeg, .jpg, .png"
                        className="file-input"
                        multiple
                        onChange={(e) => handleImageChange(e, "certificateDoc")}
                        style={{ width: "55rem" }}
                      />
                       {errors.certificateDoc && (
                        <div className="error-message">
                          {errors.certificateDoc}
                        </div>
                      )}
                      {formData.certificateDoc.length > 0 && (
                        <div  className="img-preview-container">
                          {formData.certificateDoc.map((file, index) => (
                            <div
                              key={index}
                             className="img-preview-wrapper position-relative"
                            >
                              <CardImg
                                alt="Thumbnail"
                                className="img-preview-small"
                                src={URL.createObjectURL(file)}
                                top
                                // style={{ width: '100px', height: '100px' }} // Adjust the size as needed
                              />
                              <Button
                                color="link"
                                size="sm"
                                className="position-absolute"
                                style={{ top: '0', right: '0', padding: '0' }}
                                onClick={() => handleRemoveImage("certificateDoc", index)}
                              >
                                <RiDeleteBinLine size={24} />
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <FormGroup className="upload_files">
                      <Label for="addressVerificationDoc">Address Verification Doc</Label>
                      <Input
                        type="file"
                        key={fileInputKey}
                        name="addressVerificationDoc"
                        id="addressVerificationDoc"
                        accept=".jpeg, .jpg, .png"
                        className="file-input"
                        multiple
                        onChange={(e) => handleImageChange(e, "addressVerificationDoc")}
                        style={{ width: "55rem" }}
                      />
                         {errors.addressVerificationDoc && (
                        <div className="error-message">
                          {errors.addressVerificationDoc}
                        </div>
                      )}
                      {formData.addressVerificationDoc.length > 0 && (
                          <div  className="img-preview-container">
                          {formData.addressVerificationDoc.map((file, index) => (
                            <div
                              key={index}
                              className="img-preview-wrapper position-relative"
                            >
                              <CardImg
                                alt="Thumbnail"
                                className="img-preview-small"
                                src={URL.createObjectURL(file)}
                                top
                                // style={{ width: '100px', height: '100px' }} // Adjust the size as needed
                              />
                              <Button
                                color="link"
                                size="sm"
                                className="position-absolute"
                                style={{ top: '0', right: '0', padding: '0' }}
                                onClick={() => handleRemoveImage("addressVerificationDoc", index)}
                              >
                                <RiDeleteBinLine size={24} />
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                <Container className="mt-5">
                  <FormGroup row>
                    <Label for="address" sm={2}>Address</Label>
                    <Col sm={10}>
                      <Input
                        type="text"
                        name="address"
                        id="address"
                        value={address}
                        // onChange={handleAddressChange}
                        placeholder="Enter address"
                      />
                    </Col>
                  </FormGroup>
      {coordinates.lat && coordinates.lng && (
        <div className="mt-3">
          <p><strong>Latitude:</strong> {coordinates.lat}</p>
          <p><strong>Longitude:</strong> {coordinates.lng}</p>
        </div>
      )}
    </Container>


                <Button
                  className="common-button"
                  onClick={handleSubmit}
                  color="primary"
                >
                  {"Add Provider"} {loader && <Spinner size="sm" />}
                </Button>
                <Button className="common-button-secondary" onClick={resetForm}>
                  Reset
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default AddProvider